

export const getCurrentId = state => state.currentId;
export const Bal = state => state.bal;




// WEBPACK FOOTER //
// ./src/store/getters.js